import React from 'react';

import svg from './assets/icons-16-error.svg';
import type { IconProps } from './SvgIcon';
import { SvgIcon } from './SvgIcon';
import type { ThemeColorOrCSSVar } from 'client-ribbons-design-system/types/color';

const DEFAULT_COLOR: ThemeColorOrCSSVar = `var(--functional-red-base)`;

export const IconError = (props: IconProps) => (
  <SvgIcon {...props} color={props.color ?? DEFAULT_COLOR} src={svg} testId="icon-error" />
);
